document.addEventListener("click", (event) => {
  const target =
    event.target.closest("[data-flyout-container]") ||
    event.target.closest("[data-flyout-trigger]");

  if (!target) {
    closeFlyouts();
  }
});

const flyoutTriggers = document.querySelectorAll("[data-flyout-trigger]");

flyoutTriggers.forEach((trigger) => {
  trigger.addEventListener("click", (e) => {
    e.preventDefault();

    const container = trigger.closest("[data-flyout-container]");
    const menu = container.querySelector("[data-flyout-menu]");

    menu.classList.toggle("hidden");
  });
});

const closeFlyouts = () => {
  document.querySelectorAll("[data-flyout-menu]").forEach((element) => {
    element.classList.add("hidden");
  });
};
